<template>
  <el-container>
    <!-- 导航栏 -->
    <el-header class="no-padding" height="80px">
      <div class="title">
        <div class="wrap">
          <div class="logo">
            <img src="@/assets/pass.png" alt height="40px" />
          </div>
          <el-menu
            :default-active="menuActivedIndex"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#010122"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item
              v-if="showOldIndex"
              @click="choose('oldIndex', null, '-1')"
              class="menu-item"
              index="-1"
              >首页</el-menu-item
            >
            <template v-for="(item, index) in data[0] && data[0].child">
              <el-menu-item
                @click="choose('menu', item, index + '')"
                :key="index"
                class="menu-item"
                :index="index + ''"
                >{{ item.column_name }}</el-menu-item
              >
            </template>
          </el-menu>
        </div>
        <div class="back" >
            <div class="mr" @click="resetPassword()">修改密码</div>
            <div @click="back()">退出登录</div>
          </div>
      </div>
    </el-header>
    <el-container>
      <!-- 点击二级菜单展示的视图 -->
      <el-container v-if="showIndex === 'has'">
        <!-- 侧边栏 -->
        <el-aside
          style="
            width: 280px;
            height: calc(100vh - 80px);
            overflow-y: auto;
            border-right: 1px solid #eee;
          "
        >
          <el-menu
            active-text-color="#0049B0"
            @open="onSubmenuOpen"
            :default-openeds="openeds"
          >
            <template v-for="(v, i) of sideMenu">
              <navigation-item :key="i" :item="v" />
            </template>
          </el-menu>
        </el-aside>
        <!-- 内容区 -->
        <el-container
          style="
            height: calc(100vh - 80px);
            overflow-y: auto;
            background-color: #fdfdfd;
          "
        >
          <el-main>
            <div class="bodyR">
              <div style="padding: 20px" v-if="articleInfo.article_update">
                <p style="line-height: 30px; font-size: 30px; text-align: left">
                  {{ articleInfo.article_title }}
                </p>
                <p
                  style="
                    line-height: 30px;
                    color: #999;
                    text-align: right;
                    font-size: 12px;
                  "
                >
                  <span class="left20">更新日期：</span>
                  {{ articleInfo.article_update }}
                </p>
                <div v-html="editor.info"></div>
              </div>
              <div v-else class="no-data">
                <el-empty description="请选择文章查看"></el-empty>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
      <!-- 首页展示的视图 -->
      <el-container v-else-if="showIndex === 'index'">
        <!-- 首页侧边栏 -->
        <el-aside
          style="
            width: 280px;
            height: calc(100vh - 80px);
            overflow-y: auto;
            border-right: 1px solid #eee;
          "
        >
          <el-menu
            active-text-color="#0049B0"
            @open="onSubmenuOpen"
            :default-openeds="openeds"
          >
            <el-menu-item
              @click="handleCustomNodeClick()"
              index="-1"
              style="color: rgb(0, 73, 176)"
            >
              <span>开放平台</span>
            </el-menu-item>
            <template v-for="(v, i) of indexSideMenu">
              <navigation-item :key="i" :item="v" />
            </template>
          </el-menu>
        </el-aside>
        <!-- 内容区 -->
        <el-container
          style="
            height: calc(100vh - 80px);
            overflow-y: auto;
            background-color: #fdfdfd;
          "
        >
          <el-main v-if="!showCustomMenuContent">
            <div class="bodyR">
              <div style="padding: 20px" v-if="articleInfo.article_update">
                <p style="line-height: 30px; font-size: 30px; text-align: left">
                  {{ articleInfo.article_title }}
                </p>
                <p
                  style="
                    line-height: 30px;
                    color: #999;
                    text-align: right;
                    font-size: 12px;
                  "
                >
                  <span class="left20">更新日期：</span>
                  {{ articleInfo.article_update }}
                </p>
                <div v-html="editor.info"></div>
              </div>
              <div v-else class="no-data">
                <el-empty description="请选择文章查看"></el-empty>
              </div>
            </div>
          </el-main>
          <el-main v-if="showCustomMenuContent">
            <div class="bodyR" v-if="!customMenuContentObj.customMenuContent">
              <div>
                <img src="@/assets/banner.png" alt width="100%" />
              </div>
              <p class="home-page-title">开放能力</p>
              <div style="display: flex; justify-content: space-around">
                <template v-for="(item, index) in data[0] && data[0].child">
                  <div
                    @click="choose('menu', item, index + '')"
                    :class="`group${(index + 1)%4}`"
                    :key="index"
                    v-if="!item.column_name.includes('首页')"
                  >
                    {{ item.column_name }}
                  </div>
                </template>
              </div>
            </div>
            <div v-if="customMenuContentObj.customMenuContent">
              <div class="custom-menu-title">
                {{ customMenuContentObj.column_name }}
              </div>
              <div style="padding: 0 20px 20px">
                <div
                  v-for="item in customMenuContentObj.customMenuContent"
                  :key="item.column_name"
                >
                  <p style="margin-top: 16px; font-size: 20px">
                    {{ item.column_name }}
                  </p>
                  <el-table
                    :data="item.allArticles"
                    style="width: 100%; fontsize: 14"
                    stripe
                    :header-cell-style="{
                      background: '#eef1f6',
                    }"
                  >
                    <el-table-column
                      type="index"
                      width="80"
                      label="序号"
                      style="fontsize: 14"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="article_title"
                      label="文档名称"
                      style="fontsize: 14"
                    >
                      <template slot-scope="scope">
                        <a
                          :href="
                            getDocUrl(scope.row, customMenuContentObj.column_id)
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ scope.row.article_title }}</a
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="article_outline" label="文档简介">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
      <el-container v-else-if="showIndex === 'oldIndex' && loadingOver">
        <div class="indexContent">
          <div id="content" v-html="content"></div>
        </div>
      </el-container>
      <el-container v-else>
        <div class="no-data">
          <el-empty description="暂无内容"></el-empty>
        </div>
      </el-container>
    </el-container>

    <a-modal :visible="setPassVisible" title="修改密码" cancelText="取消" okText="确定"
          wrapClassName="reset-pass"  @ok="handleOk" @cancel="setPassVisible = false;">
           <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }" >
            <a-form-item label="旧密码">
              <a-input-password
                v-decorator="['orignPass', { rules: [{ required: true, message: '请输入旧密码!' }] }]"
              />
            </a-form-item>

            <a-form-item label="新密码">
                <a-input-password
                  v-decorator="['newPass', { rules: [{ required: true, message: '请输入新密码!' }] }]"
                />
            </a-form-item>

            <a-form-item label="确认密码">
                <a-input-password
                  v-decorator="['confirmPass', { rules: [{ required: true, message: '请输入确认密码!' }] }]"
                />
              </a-form-item>
          </a-form>
        </a-modal>
  </el-container>
</template>
<script>
import "@/assets/css/base.css";
import { indexContent } from "@/config";
import NavigationItem from "@/components/navigation-item.vue";
import { bus } from "@/main";
import { getArticlesOfSubMenu } from "./CMS/vuex/store";
import { resetPass } from "@/api/api.js"
import Vue from "vue";
import dayjs from "dayjs";
const key = ["oldIndex", "index", "has", "no"];

export default {
  components: {
    "navigation-item": NavigationItem,
  },
  data() {
    return {
      jumpId: "", // 跳转标签携带的id和columnId
      jumpColumnId: "",
      jumpHeaderId: "",
      jumpMenuActivedIndex: "",
      openeds: [], // 快速跳转后左侧菜单展开数组
      loadingSubMenu: false,
      signLoadEditorStyle: false,
      data: [],
      allArticles: [], // 所有文章
      apiListColumnIds: {}, // 首页apiList下所有id集合
      menuActivedIndex: "0", // 菜单索引
      asideMenuActivedIndex: "-1", // 侧边菜单索引

      loadingOver: false, // 是否加载结束
      showOldIndex: true, // 是否展示旧首页，和新首页互斥
      showIndex: key[0],
      showCustomMenuContent: false, // 自定义菜单点击后展示内容
      customMenuContentObj: {}, // 自定义菜单点击后展示内容,该菜单下的所有文档
      apiList: [], // 首页api列表下展示菜单
      indexSideMenu: [], // 首页侧边菜单栏
      sideMenu: [],
      articleInfo: {},

      content: indexContent,
      isvisible: false,
      style1: {
        height: "",
        textAlign: "left",
        marginTop: "10px",
        fontSize: "14px",
        lineHeight: "1.6",
      },
      style2: {
        left: "",
      },
      height: "calc(100vh - 200px)",
      editor: {
        info: "",
      },
      isClear: false,
      obj: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      time: null,

      setPassVisible: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  methods: {
    getDocUrl(obj, headerId) {
      return `/open/passIndex?id=${obj.id}&column_id=${obj.column_id}&headerId=${headerId}`;
    },

    groupingAllArticles(column_id) {
      // 将所有文档分类到各个分组下
      console.log(this.allArticle.allArticleList);
      const customColumn = this.apiListColumnIds[column_id];
      this.allArticle.allArticleList.forEach((item) => {
        if (
          customColumn.ids.includes(parseInt(item.column_id)) &&
          item.article_id
        ) {
          customColumn.child.forEach((item1) => {
            // 将文档进行处理插入一级菜单中
            if (
              customColumn.level1MenuAndIds[item1.column_name].includes(
                parseInt(item.column_id)
              )
            ) {
              if (item1.allArticles) item1.allArticles.push(item);
              else item1.allArticles = [item];
            }
          });
          customColumn.articles.push(item);
        }
      });
    },

    onSubmenuOpen(index) {
      if (this.loadingSubMenu) {
        return;
      }
      let treeNode = this.mapOfSideMenu[index];
      this.loadingSubMenu = true;
      getArticlesOfSubMenu(treeNode.id)
        .then((res) => {
          const data = res.data.data[0].children; // 该菜单下所包含的文档
          if (data.length) {
            this.$forceUpdate();
            this.findMenuAndUpdate(index, this.sideMenu, data);
            this.findMenuAndUpdate(index, this.indexSideMenu, data); // 新首页menu处理

            this.indexSideMenu = JSON.parse(JSON.stringify(this.sideMenu)); // 新首页menu处理
            this.sideMenu = JSON.parse(JSON.stringify(this.sideMenu));
          }
        })
        .finally(() => {
          this.loadingSubMenu = false;
        });
    },
    findMenuAndUpdate(columnId, menu, data) {
      for (let i = 0; i < menu.length; i++) {
        const currentColumnId = menu[i]["column_id"];
        if (currentColumnId === columnId) {
          Vue.set(
            menu,
            i,
            Object.assign({}, menu[i], {
              children: data,
            })
          );
          break;
        } else {
          if (menu[i].child && menu[i].child.length) {
            this.findMenuAndUpdate(columnId, menu[i].child, data);
          }
        }
      }
    },
    choose(type, param, i) {
      if (this.apiList.length === 0) {
        this.data[0].child.forEach((item) => {
          if (!item.column_name.includes("首页")) {
            this.apiList.push({
              column_id: item.column_id,
              column_name: item.column_name,
              id: item.id,
              parent_id: item.parent_id,
              customMenuItem: true, // 是否是自定义添加的按钮
            });
          }
        });
      }
      const _this = this;
      this.editor.info = "";
      this.articleInfo = {};

      console.log(type, param);
      switch (type) {
        case "oldIndex":
          this.showIndex = key[0];
          break;
        case "menu":
          this.sideMenu.length = 0;
          // TODO: 选中菜单，切换栏目视图
          const articleList = param.children || [];
          let columnList = param.child || [];
          //
          if (param.id === 5) {
            const loginInfoStr = localStorage.getItem("loginInfo");
            const loginInfo = JSON.parse(loginInfoStr);
            const roleIds = loginInfo.role_ids.split(",");
            if (loginInfo.admin) {
              // 如果是管理员展示全部
              columnList = columnList.filter((v) => {
                return v.id + "";
              });
            } else {
              columnList = columnList.filter((v) => {
                return roleIds.includes(v.id + "");
              });
            }
          }
          this.sideMenu = columnList.concat(articleList);
          if (param.column_name.includes("首页")) {
            _this.openeds = [];
            this.showIndex = "index";
            this.showCustomMenuContent = true;
            this.customMenuContentObj = {
              column_id: "",
              column_name: "",
              customMenuContent: null,
            };
            this.indexSideMenu = columnList.concat(articleList);
            this.indexSideMenu.forEach((item) => {
              if (item.column_name.includes("API列表") && !item.child) {
                item.child = _this.apiList;
              }
            });
          } else {
            this.menuActivedIndex = i + "";
            this.showCustomMenuContent = false;
            this.showIndex = this.sideMenu.length ? key[2] : key[3];
          }

          console.log(this.mapOfSideMenu);
          console.log(this.sideMenu);
          break;
      }
    },

    setSideMenuMap(menu) {
      for (let i = 0; i < menu.length; i++) {
        const current = menu[i];
        this.mapOfSideMenu[current.column_id] = current;
        if (menu.child && menu.child.length) {
          this.setSideMenuMap(menu.child);
        }
      }
    },
    handleCustomNodeClick(data) {
      this.showCustomMenuContent = true;
      if (!data) {
        // 开放平台文档介绍
        this.customMenuContentObj = {
          column_id: "",
          column_name: "",
          customMenuContent: null,
        };
        return;
      }
      const index = data.column_id;
      if (this.apiListColumnIds[index].articles.length === 0) {
        this.groupingAllArticles(index);
      }
      // 首页API列表下menu点击事件
      this.customMenuContentObj = {
        column_id: index,
        column_name: this.apiListColumnIds[index].column_name,
        customMenuContent: this.apiListColumnIds[index].child,
      };
    },
    handleNodeClick(data) {
      this.showCustomMenuContent = false;
      if (data.article_content) {
        data.article_update = dayjs(data.article_update).format(
          "YYYY-MM-DD HH:mm"
        );
        this.editor.info = data.article_content;
        this.articleInfo = data;
        this.$nextTick(() => {
          if (!this.signLoadEditorStyle) {
            uParse(".bodyR", {
              rootPath: "/UEditor",
            });
            this.signLoadEditorStyle = true;
          }
        });
      } else {
        this.editor.info = "";
        this.articleInfo = {};
      }
    },
    getFirst() {
      if (this.data.length) {
        if (!this.jumpId && !this.jumpColumnId) {
          // 非跳转，首次进入首页的开发平台文档介绍
          if (this.showOldIndex) {
            this.menuActivedIndex = "-1";
          } else {
            this.data[0].child.forEach((item, index) => {
              if (item.column_name.includes("首页")) {
                this.menuActivedIndex = index + "";
                this.choose("menu", item);
                this.handleCustomNodeClick();
              }
            });
          }
        } else {
          // 定位对应文档位置
          this.data[0].child.forEach((item, index) => {
            if (item.column_id === this.jumpHeaderId) {
              this.choose("menu", item, index + "");
            }
          });
          this.getOpeneds(this.jumpColumnId);
          this.openeds.splice(0, 2); // 删除展开的前两位
          this.onSubmenuOpen(this.openeds[this.openeds.length - 1]);
          this.allArticle.allArticleList.forEach((item) => {
            if (parseInt(item.id) === parseInt(this.jumpId)) {
              this.handleNodeClick(item);
            }
          });
        }
        return;
      }

      this.data[0].child.forEach((item) => {
        if (item.child && item.child.length > 0) {
          if (item.child[0].child && item.child[0].child.length > 0) {
            this.obj(item.child[0]);
          }
        }
      });
    },
    back() {
      localStorage.removeItem("loginInfo");
      this.$router.push("/login");
    },
    getOpeneds(columnId) {
      const menuOriginal = this.$store.state.pass.menuOriginal;
      for (let i = 0; i < menuOriginal.length; i++) {
        if (
          menuOriginal[i].id === parseInt(columnId) &&
          menuOriginal[i].parent_id
        ) {
          this.openeds.unshift(menuOriginal[i].column_id);
          this.getOpeneds(menuOriginal[i].parent_id);
          break;
        }
      }
    },
    getCustomMenuAllIds(column, column_id) {
      // 获取自定义菜单下的所有menuItem的id集合
      column.child.forEach((item) => {
        this.apiListColumnIds[column_id].ids.push(item.id);
        if (item.child && item.child.length > 0) {
          this.getCustomMenuAllIds(item, column_id);
        }
      });
    },
    getCustomLevel1MenuAllIds(column, column_id, column_name) {
      // 获取自定义菜单下的所有以及菜单的id集合
      column.child.forEach((item) => {
        this.apiListColumnIds[column_id].level1MenuAndIds[column_name].push(
          item.id
        );
        if (item.child && item.child.length > 0) {
          this.getCustomMenuAllIds(item, column_id, column_name);
        }
      });
    },
    resetPassword() {
      this.form.resetFields();
      this.setPassVisible = true;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.newPass !== values.confirmPass) {
            this.$message.error('新密码和确认密码不一致!');
            return;
          }

          if (values.orignPass === values.newPass) {
            this.$message.error('新密码和旧密码不能一样!');
            return;
          }

          if (values.newPass.length < 6) {
            this.$message.error('新密码长度最少6位!');
            return;
          }

          const loginInfoStr = localStorage.getItem("loginInfo");
          const loginInfo = JSON.parse(loginInfoStr);
          const username = loginInfo.username;
          values.username = username;
          resetPass(values).then((res) => {
            if (res.data.code === 0) {
              this.$message.success("更新成功");
              this.setPassVisible = false;
            } else {
              this.$message.error(res.data.message || '出错啦~');
            }
          })
        }
      });
    }
  },
  watch: {
    "$store.state.allArticle.allArticleList"() {
      // 所有文档获取结束，显示跳转文档
      if (this.jumpId) {
        this.allArticle.allArticleList.forEach((item) => {
          if (parseInt(item.id) === parseInt(this.jumpId)) {
            this.handleNodeClick(item);
          }
        });
      }
    },

    tableDataAll: function (a, b) {
      if (!a || a.length === 0) {
        this.data = [];
        this.indexSideMenu = [];
      }
      a.forEach((item) => {
        if (item.id === 3) {
          this.data = item.child ? item.child : [];
        }
      });
      this.data[0].child.forEach((item) => {
        if (!item.column_name.includes("首页")) {
          this.apiListColumnIds[item.column_id] = {
            child: item.child,
            ids: [],
            level1MenuAndIds: [],
            articles: [],
            column_name: item.column_name,
          };
          if (item.child && item.child.length > 0) {
            // 获取自定义菜单下的所有menuItem的id集合
            item.child.forEach((item1) => {
              this.apiListColumnIds[item.column_id].level1MenuAndIds[
                item1.column_name
              ] = [item1.id];

              if (item1.child && item1.child.length > 0) {
                this.getCustomLevel1MenuAllIds(
                  item1,
                  item.column_id,
                  item1.column_name
                );
              }
            });
            this.getCustomMenuAllIds(
              this.apiListColumnIds[item.column_id],
              item.column_id
            );
          }
        } else {
          // 存在首页菜单，则不展示旧首页
          this.showOldIndex = false;
        }
        this.loadingOver = true;
      });
      this.getFirst();
    },
    sideMenu: function (newVal, oldVal) {
      console.log(newVal, oldVal);
    },
  },
  computed: {
    pass: function () {
      return this.$store.state.pass;
    },
    allArticle: function () {
      return this.$store.state.allArticle;
    },
    tableDataAll: function () {
      return this.$store.state.pass.tableDataAll;
    },
    userinfo: function () {
      return this.$store.state.info;
    },
    mapOfSideMenu: function () {
      return this.$store.state.pass.mapOfSideMenu;
    },
  },
  mounted() {
    const t = this;
    const loginInfoStr = localStorage.getItem("loginInfo");
    if (!loginInfoStr) {
      this.$router.push("/login");
    }
    this.$store.commit("addOrOptionEditor", true);
    t.style1.height = window.innerHeight - 100 + "px";
    t.style2.left =
      document.getElementsByClassName("logo")[0].offsetLeft + "px";

    bus.$on("menuClick", (data) => {
      this.handleNodeClick(data);
    });
    bus.$on("customMenuClick", (data) => {
      this.handleCustomNodeClick(data);
    });
  },
  created() {
    // console.log(
    //   "----------------",
    //   this.$route.query.id,
    //   this.$route.query.column_id
    // );
    if (this.$route.query.id && this.$route.query.column_id) {
      this.jumpId = this.$route.query.id;
      this.jumpColumnId = this.$route.query.column_id;
      this.jumpHeaderId = this.$route.query.headerId;
    }
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    this.$store.commit("setInfo", userInfo);
    // 获取登录信息
    const loginInfoStr = localStorage.getItem("loginInfo");
    // 存在获取，不存在空
    if (loginInfoStr) {
      const result = JSON.parse(loginInfoStr);
      const list = result.role_ids.split(",");
      this.$store.state.pass.getPassList(3, list, result.admin);
      this.$store.state.allArticle.getAllArticleList();
    } else {
      this.data = [];
      this.sideMenu = [];
    }
  },
};
</script>

<style scoped lang="less">
@import "./pass.css";
.back {
    color: #fff;
    cursor: pointer;
    position: fixed;
    right: 20px;
    top: 0;
    display: flex;
    .mr {
      margin-right: 16px;
    }
}
.wrap {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  .el-menu-demo {
    flex: 1;
    li {
      clear: none !important;
    }
  }
}

.menu-item {
  height: 80px !important;
  line-height: 80px !important;

  &:hover {
    background-color: #434a50 !important;
  }
}

.indexContent {
  width: 1200px;
  margin: 0 auto;
}

.custom-menu-title {
  padding-left: 20px;
  line-height: 30px;
  font-size: 30px;
  margin: 16px 0;
  text-align: left;
}
.home-page-title {
  margin: 48px 0;
  height: 50px;
  line-height: 50px;
  font-weight: 600;
  font-size: 36px;
  color: #333333;
  text-align: center;
}
.group1,
.group2,
.group3,
.group4 {
  width: 200px;
  height: 180px;
  padding-top: 148px;
  line-height: 32px;
  font-size: 24px;
  color: #333333;
  text-align: center;
  cursor: pointer;
}
.group1 {
  background: url("../assets/group1.png") no-repeat center 0;
}
.group2 {
  background: url("../assets/group2.png") no-repeat center 0;
}
.group3 {
  background: url("../assets/group3.png") no-repeat center 0;
}
.group4 {
  background: url("../assets/group4.png") no-repeat center 0;
}
</style>
